import { useMemo } from 'react';
import { Templates } from '@thive/fddm-types';

import { useAppStore } from '@modules/app/store/useAppStore';
import { filterTemplatesByIds } from '@/modules/floorplanDesign/helpers/helpers';

import { useFloorplanDesignStore } from '../store/useFloorplanDesignStore';

export const useReadSelectedTemplates = (): Templates => {
  const ids = useAppStore((state) => state.selectedIds);
  const allTemplates = useFloorplanDesignStore((state) => state.design.templates);
  return useMemo(() => filterTemplatesByIds(allTemplates, ids), [allTemplates, ids]);
};
